import { removeScript } from 'utils/script';
import { useEditorContext } from '../../contexts/editor';
import { LinkTarget } from '../types';

export const useInsertNewHyperlink = () => {
  const { editor } = useEditorContext();

  return (displayText: string, href: string, target: LinkTarget) => {
    const link = document.createElement('a');
    link.textContent = removeScript(displayText);
    link.href = removeScript(href);
    link.target = target;
    editor?.insertContent(link.outerHTML);
  };
};
